import ClientLike from "@/api/client-like";
import Unit from "../entities/unit";

export default class UnitApi {
  constructor(private client: ClientLike) {}

  /**
   * 単位の一覧を取得する
   */
  public async findAll(): Promise<Unit[]> {
    const res = await this.client.get("get_unit.php");
    return res.units.map(this.buildUnit);
  }

  /**
   * 単位を保存する
   */
  public async save(unit: Unit): Promise<void> {
    const d = new FormData();
    d.append("id", String(unit.id || ""));
    d.append("name", unit.name);
    await this.client.post("save_unit.php", d);
  }

  /**
   * 単位を削除する
   */
  public async destroy(unit: Unit): Promise<void> {
    const d = new FormData();
    d.append("id", String(unit.id));
    await this.client.post("delete_unit.php", d);
  }

  /**
   * 単位を並べ替える
   */
  public async sort(units: Unit[]): Promise<void> {
    const d = new FormData();
    units.forEach((u, i) => {
      d.append(`units[${i}]`, String(u.id));
    });
    await this.client.post("sort_unit.php", d);
  }

  private buildUnit(u: any): Unit {
    return new Unit(u.id, u.name);
  }
}
